import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-emoji-rating',
  template: `
    <div class="mb-3">
      <div class="mb-2">
        {{ props.label }}
        <span *ngIf="props.required" class="text-danger">*</span>
      </div>
      <div class="d-flex emoji-container">
        <button
          *ngFor="
            let emoji of props['emojiIcons'];
            let j = index;
            let isFirst = first;
            let isLast = last
          "
          type="button"
          class="p-0 emoji-btn"
          [class.active]="formControl.value === j + 1"
          [class.first-btn]="isFirst"
          [class.last-btn]="isLast"
          (click)="setValue(j + 1)"
        >
          <mat-icon class="emoji-icon material-symbols-outlined">{{
            emoji
          }}</mat-icon>
          <span *ngIf="props['showLabels']" class="emoji-label small">
            {{ props['emojiLabels']?.[j] }}
          </span>
        </button>
      </div>
    </div>

    <div *ngIf="showError" class="text-danger small mt-1">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  `,
  styles: [
    `
      .emoji-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border: 1px solid #dee2e6;
        border-radius: 0 !important;
        border-left: none;
        border-right: none;
        text-decoration: none;
        background: #fff;
        transition: none !important;
        box-shadow: none !important;
        overflow: hidden;
        width: 100%;
        font-weight: bold;
        font-size: 16px;
        color: var(--color-primary);

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 20%;
          bottom: 20%;
          width: 1px;
          background: #dee2e6;
        }

        &:hover::after {
          display: none !important;
        }

        &.first-btn {
          border-radius: 50px 0 0 50px !important;
          border-left: 1px solid #dee2e6;
        }

        &.last-btn {
          border-radius: 0 50px 50px 0 !important;
          border-right: 1px solid #dee2e6;

          &::after {
            display: none;
          }
        }

        &:hover {
          background-color: var(--color-primary-light);
          border-top-color: var(--color-primary-light);
          border-bottom-color: var(--color-primary-light);

          &.first-btn {
            border-left-color: var(--color-primary-light);
          }

          &.last-btn {
            border-right-color: var(--color-primary-light);
          }

          &::after {
            background: var(--color-primary-light);
          }

          .emoji-icon {
            color: white;
          }
        }

        &.active {
          background-color: var(--color-primary) !important;
          border-top-color: var(--color-primary) !important;
          border-bottom-color: var(--color-primary) !important;
          box-shadow: none !important;

          &.first-btn {
            border-left-color: var(--color-primary) !important;
          }

          &.last-btn {
            border-right-color: var(--color-primary) !important;
          }

          &::after {
            background: var(--color-primary) !important;
            display: none !important;
          }

          .emoji-icon {
            color: white;
          }
        }
      }

      .emoji {
        font-size: 24px;
        transition: transform 0.2s;
      }

      .emoji-icon {
        font-size: 32px;
        width: 32px;
        height: 32px;
      }

      .emoji-label {
        display: block;
        margin-top: 4px;
        white-space: nowrap;
        font-size: 10px;
      }
    `,
  ],
  standalone: false,
})
export class EmojiRatingType extends FieldType {
  setValue(value: number) {
    this.formControl.setValue(value);
    this.formControl.markAsTouched();
  }
}